<template>
	<div class="logistics-goods">
		<div class="query-setting-box">
			<div class="query-setting-box-left">
				<div class="order-query-form-box" style="width: 400px;margin-top:-10px;">
					<label for="start-date">下单时间：</label>
					<span class="order-query-form-input">
						<!-- <el-date-picker  :picker-options="createTimeBegin" v-model="orderForm.createTimeBegin" type="datetime" placeholder="选择日期时间"
							class="setTimePicker" value-format="yyyy-MM-dd HH:mm:ss">
						</el-date-picker> -->
						<el-date-picker
						    v-model="time"
						    type="datetimerange"
						    range-separator="至"
						    start-placeholder="开始日期"
						    end-placeholder="结束日期"
						    :picker-options="pickerOptions"
							value-format="yyyy-MM-dd HH:mm:ss"
							format="yyyy-MM-dd HH:mm:ss"
						   :default-time="['00:00:00', '23:59:00']"
							  >
						   </el-date-picker>
					</span>
							
					
				</div>
				<div class="order-query-form-box">
					<label for="start-date">订单号：</label>
					<span class="order-query-form-input"><input type="text" v-model="orderForm.waybillNo"
							name="start-date"></span>
				</div>
				<div class="order-query-form-box">
					<label for="start-date">货主名称：</label>
					<span class="order-query-form-input"><input type="text" v-model="orderForm.ownerName"
							name="start-date"></span>
				</div>
				<div class="order-query-form-box">
					<label for="start-date">货主手机：</label>
					<span class="order-query-form-input"><input type="text" v-model="orderForm.ownerPhone"
							name="start-date"></span>
				</div>
				<div class="order-query-form-box">
					<label for="start-date">车牌号：</label>
					<span class="order-query-form-input"><input type="text" v-model="orderForm.driverCarNo"
							name="start-date"></span>
				</div>
				<div class="order-query-form-box">
					<label for="start-date">司机姓名：</label>
					<span class="order-query-form-input"><input type="text" v-model="orderForm.driverName"
							name="start-date"></span>
				</div>
				<div class="order-query-form-box">
					<label for="start-date">司机手机：</label>
					<span class="order-query-form-input"><input type="text" v-model="orderForm.driverPhone"
							name="start-date"></span>
				</div>
				<div class="order-query-form-box">
					<label for="start-date">订单状态：</label>
					<span class="order-query-form-input">
						<el-select v-model="orderForm.waybillState" placeholder="请选择" class="stSetSelect">
							<el-option v-for="item in waybillStateList" :key="item.value" :label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
					</span>
				</div>
				<div class="order-query-form-box" style="width: 80px;">
					<label for="st-is-order">双通订单</label>
					<span class="order-query-form-input"><input type="checkbox" v-model="orderForm.stWaybillFlag"
							class="st-checkbox" id="st-is-order"></span>
				</div>
			</div>
			<div class="order-query-form-box-right">
				<span class="order-query-form-submit stPointer" @click="searchList(true)">查询</span>
			</div>
		</div>
		<div class="data-table-box">
			<common-table ref="CommonTableRef" :tableColumns="tableColumns" :data="dataList" :showPage="togglePage"
				:loading="loading" :pageConfig="pageConfig" :bottomHandleArr="bottomHandleArr"
				@selectionChange="selectionChange" @currentChange="currentChange" @sizeChange="sizeChange">
			</common-table>
		</div>

	</div>
</template>
<script>
	export default {
		name: 'LogisticsGoods',
		props: [],
		components: {},
		data() {
			return {
				time:[],
				 //不能选择当前日期之后的时间
				    pickerOptions: {
				        disabledDate(time) {
				          return time.getTime() > Date.now();
				        }
				      },
				dataList: [], //订单列表
				loading: false,
				pageConfig: {
					total: 0,
					pageSize: 100,
					currentPage: 1,
				},
				togglePage:false,
				bottomHandleArr: [
					{
						label: '确认收货',
						type: 'success',
						handler: () => this.confirmReceipt()
					},
					{
						label: '导出',
						type: 'success',
						handler: () => this.exportTable()
					},
				],
				tableColumns: [
					{
						type: 'selection',
						fixed: 'left',
					},
					{
						index: true,
						fixed: 'left',
						title: '序号',
					},
					{
						title: '下单时间',
						key: 'createTimeFormatted',
					},
					{
						title: '订单号',
						key: 'waybillNo',
					},
					{
						title: '是否收货',
						key: 'completeOfSt',
					},
					{
						title: '始发地',
						key: 'consignShortAddress',
					},
					{
						title: '目的地',
						key: 'receiveShortAddress',
					},
					{
						title: '货主名称',
						key: 'ownerName',
					},
					{
						title: '货主手机',
						key: 'ownerPhone',
					},
					{
						title: '车牌号',
						key: 'address',
					},
					{
						title: '司机姓名',
						key: 'driverName',
					},
					{
						title: '司机手机',
						key: 'driverPhone',
					}
				],
				orderForm: {
					createTimeBegin: null, // 下单起始时间  string  格式：yyyy-MM-dd HH:mm:ss
					createTimeEnd: null, // 下单结束时间  string  格式：yyyy-MM-dd HH:mm:ss
					waybillNo: null, // 订单号 number  
					ownerName: null, // 货主名称  string  
					driverCarNo: null, // 车牌号 string  
					driverName: null, //  司机姓名  string  
					driverPhone: null, // 司机手机  string  
					ownerPhone: null, //  货主手机  string  
					stWaybillFlag: false, // 双通物流订单  boolean false=否、true=是
					waybillState: "0", // 运单状态 number 0 = 未接单、 1 = 已接单、 2 = 运输中、 3 = 已完成、 99 = 已取消
				},
				selectedList: [],// 选中的列表
				waybillStateList: [{
					value: '0',
					label: '未接单'
				}, {
					value: '1',
					label: '已接单'
				}, {
					value: '2',
					label: '运输中'
				}, {
					value: '3',
					label: '已完成'
				}, {
					value: '99',
					label: '已取消'
				}],

			}
		},
		created() { },
		methods: {
			selectionChange(val) {
				this.selectedList = val;
			},

			sizeChange(size) {
				this.pageConfig.currentPage = 1
				this.pageConfig.pageSize = size
				this.searchList()
			},

			currentChange(currentPage) {
				this.pageConfig.currentPage = currentPage
				this.searchList()
			},

			searchList(flag) {
				let pages = {};
				pages.size = this.pageConfig.pageSize;
				pages.current = this.pageConfig.currentPage;
				if(flag) pages.current = 1;
				this.loading = true
				let orderForm = this.orderForm;
				Object.assign(orderForm, pages)
				this.getData(orderForm)
			},

			getData(data) {
				// data.createTimeBegin = this.time[0]
				// data.createTimeEnd = this.time[1]
				// data.createTimeBegin = data.createTimeBegin ? new Date(data.createTimeBegin).getTime() : ''
				// data.createTimeEnd = data.createTimeEnd ? new Date(data.createTimeEnd).getTime() : ''
				this.$server.business.waybillPage(data, (res) => {
					this.loading = false
					if (res.code == 0) {
						this.dataList = res.data.records;
						this.pageConfig.total = res.data.total;
						this.pageConfig.currentPage = res.data.current;
						if(res.data.total>0){
							this.togglePage=true;
						}
					}
				})
			},
			// 确认收货    双通订单才有效
			confirmReceipt() {
				let that = this;
				let waybillNoList = [];
				if (this.selectedList.length > 0) {
					this.selectedList.forEach(item => {
						waybillNoList.push(item.waybillNo)
					});
				}
				this.$server.business.completeSt(waybillNoList, (res) => {
					if (res.code === 0) {
						that.$toast.stMessage('操作成功', true)
					} else {
						that.$toast.stMessage(res.message, false)
					}
				})
			},
			// 导出
			exportTable() {
				let that = this;
				if (this.dataList.length < 1) {
					that.$toast.stMessage('暂无订单', true)
					return;
				}
				let pages = {};
				pages.size = this.pageConfig.pageSize;
				pages.current = this.pageConfig.currentPage
				let orderForm = this.orderForm;
				Object.assign(orderForm, pages)
				this.$server.business.waybillPageExport(orderForm, (res) => {
					var blob = new Blob([res.data], {
						type: "application/vnd.ms-excel;charset=UTF-8"
					});
					var objectUrl = URL.createObjectURL(blob);
					var a = document.createElement('a');
					a.href = objectUrl;
					//导出文件名
					var fileName = new Date().getTime();
					a.download = "数据表格-" + fileName + ".xls";
					a.target = '_blank';
					a.click();
				})



			},
		},
		mounted() {
// 查看近一周时间
			const end = new Date();
			const start = new Date();
			start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
			// picker.$emit('pick', [start, end]);
			this.time = [start,end]
			console.log( this.time )
		}
	}

</script>
<style scoped lang="scss">
	.logistics-goods {
		display: flex;
		flex-direction: column;
		width: 100%;
		height: 100%;
	}

	.data-table-warp {

		width: auto;
		margin: 0 auto;
	}

	.data-table {
		margin-bottom: 8px;
	}
</style>